import EmailConfirmationSuccess from './EmailConfirmationSuccess';

export default EmailConfirmationSuccess;
